import ReactDOM from 'react-dom/client'
import './index.css'
import {
  createBrowserRouter
} from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import App from './App';
import { BaseRouter } from './infra/routes/baseRoutes';
import { ThemeProvider } from './utils/context/themeContext';
import SideBarOptions from './utils/SideBarOptions';
import { ConfigHeadHtml } from './head';
import 'base/i18n';
import { LangList, StartLang } from 'base/i18n';
import { Either } from './utils/propsUtil';

import { RootBaseReducerList } from './store/baseStore';
import { combineReducers } from 'redux'
import PageNotFound from './view/error/PageNotFound';
import { CustomProvider, ReactRouteObject } from './utils/routeUtil';
import { AddRoute, IgnoreAuth, IgnoreHeader, IgnoreSideBar, SetSideBar, StartState } from './store/util/action/utilAction';
import 'base/src/styles/basic.css';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import { UserData } from './infra/storage/localStorage';
import { scan } from "react-scan"; // must be imported before React and React DOM
import { IsDebug, IsTest } from 'domain/utils/domainUtil';
import DynamicRouterProvider from './components/DynamicRouterProvider';

interface Props0 {
  titulo: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  storeRoot: any;
  sidebarOptions?: Array<SideBarOptions>
  langList: LangList,
  sistemaID: number,
  customWrapper?: React.ComponentType<CustomProvider>
}
interface Props1 {
  startComponent?: JSX.Element,
  headerLeftInfo?: React.ReactNode | JSX.Element
}
interface Props2 {
  routes?: ReactRouteObject[]
}

export type StartProps = Props0 & Either<Props1, Props2>;

export let StoreAplication = configureStore({ reducer: {} })

if (!IsTest()) {
  scan({
    enabled: false,
    showToolbar: false
  });
}

//const defaultValue: StartProps = {
//} as StartProps


export function Start(props: StartProps) {
  //props = {...defaultValue, ...props}
  props = {...props, sidebarOptions:props.sidebarOptions && props.sidebarOptions.filter(e=>IsDebug() ? true : (IsDebug() == false && !e.isDev))}
  
  StartLang(props.langList);
  ConfigHeadHtml(props.titulo);

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  const persistConfig = {
    key: "root",
    storage,
    whitelist: ["CampanhaPedidoResgateReducer.formData"],
  };

  const rootReducer = combineReducers({
    ...RootBaseReducerList,
    ...props.storeRoot
  });

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  StoreAplication = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });

  const persistor = persistStore(StoreAplication);

  // Função para detectar se estamos em ambiente de desenvolvimento com base URL
  function getBasename(): string {
    // Verifica se estamos em build:dev usando variáveis de ambiente
    const isDev = import.meta.env.MODE === 'development';
    const baseUrl = import.meta.env.BASE_URL;
    
    // Se está em desenvolvimento e tem uma base URL diferente de '/', usa ela
    if (isDev && baseUrl && baseUrl !== '/') {
      return baseUrl.replace(/\/$/, ''); // Remove trailing slash
    }
    
    return '/';
  }

  const basename = getBasename();
  const defaultRouter = createBrowserRouter(BaseRouter, { basename });

  const allRoutes = props.routes ? [...props.routes.filter(e=>IsDebug() ? true : (IsDebug() == false && !e.isDev)),
  {
    path: "error",
    element: <PageNotFound />,
    ignoreAuth: true,
    ignoreHeader: true,
    ignoreSideBar: true
  } as ReactRouteObject,
  ] : undefined

  if (allRoutes)
    allRoutes.forEach(r => {
      if (r.ignoreAuth) {
        StoreAplication.dispatch(IgnoreAuth(r.path))
      }
      if (r.ignoreSideBar) {
        StoreAplication.dispatch(IgnoreSideBar(r.path))
      }
      if (r.ignoreHeader) {
        StoreAplication.dispatch(IgnoreHeader(r.path))
      }

      r.path && StoreAplication.dispatch(AddRoute({Path:r.path, Status:r.initialState ?? true}))
      StoreAplication.dispatch(StartState(true))
    })

    props.sidebarOptions && StoreAplication.dispatch(SetSideBar(props.sidebarOptions)) //Define as sidebar para acesso publico em todo app
  
  UserData.LoadUserDataState()

  root.render(
    <Provider store={StoreAplication}>
      <PersistGate loading={null} persistor={persistor}>
        {props.startComponent ? (
          <ThemeProvider>
            <App customWrapper={props.customWrapper} routes={allRoutes} sistemaID={props.sistemaID} SidebarOptions={props.sidebarOptions} headerLeftInfo={props.headerLeftInfo}>{props.startComponent}</App>
          </ThemeProvider>
        ) : (
          <ThemeProvider>
            <DynamicRouterProvider 
              routes={allRoutes}
              fallbackElement={<PageNotFound />}
              sistemaID={props.sistemaID}
              sidebarOptions={props.sidebarOptions}
              headerLeftInfo={props.headerLeftInfo}
              customWrapper={props.customWrapper}
              defaultRouter={defaultRouter}
            />
          </ThemeProvider>
        )}
      </PersistGate>
    </Provider>
  );
}